import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

function SectionTitle(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		fontSize: context.themeManager.value('block-title', 'fontSize', 'font-size-200'),
		padding: '0 0 0.4em 0',
		margin: '0 0 0.8em 0',
		background: `linear-gradient(to right, rgb(51, 51, 51) 20%, rgba(255, 255, 255, 0) 0%)
		center bottom / 5px 1px repeat-x transparent`,
		textTransform: 'uppercase',
		textAlign: 'center',
		'@media(min-width : 768px)': {
			textAlign: 'left',
		},
	};
	const randomId = parseInt(String(Math.random() * 100000), 10);
	const Headline = props.headlineLevel? props.headlineLevel : 'h1';
	return (
		<Headline className="section__title" style={style} id={props.id ? props.id : randomId}>
			{props.children}
		</Headline>
	);
}

export default radium(SectionTitle);
